// extracted by mini-css-extract-plugin
export default {"root":"SearchBar_root__z+QBT","input":"SearchBar_input__Gs4k1"};